import React from "react";
import { Link } from "react-router-dom";
import { ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

import { KeyValue } from "@/main/models/common";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { getTranslateByKey } from "@/main/services/utils";

import * as S from "./styles";

interface IRegisterMenuProps extends React.HTMLAttributes<HTMLDivElement> {}

function RegisterMenu(props: IRegisterMenuProps) {
	const [isOpen, setIsOpen] = React.useState<boolean>(false);
	const anchorRef = React.useRef<HTMLButtonElement>(null);

	const handleToggle = () => {
		setIsOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event: React.MouseEvent<EventTarget>) => {
		if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
			return;
		}

		setIsOpen(false);
	};

	function handleListKeyDown(event: React.KeyboardEvent) {
		if (event.key === "Tab") {
			event.preventDefault();
			setIsOpen(false);
		}
	}

	const prevOpen = React.useRef<boolean>(isOpen);

	const OPTIONS_REGISTER: KeyValue[] = [
		{
			key: RoutesConstants.bodyshopRegisterPublic,
			value: getTranslateByKey("companyType.bodyshop"),
		},
		{
			key: RoutesConstants.supplierRegisterPublic,
			value: getTranslateByKey("companyType.supplier"),
		},
	];

	React.useEffect(() => {
		if (prevOpen.current === true && isOpen === false) {
			anchorRef.current!.focus();
		}

		prevOpen.current = isOpen;
	}, [isOpen]);
	return (
		<S.Container {...props}>
			<S.StyledButton
				ref={anchorRef}
				aria-controls="id-homepage-register-dropdown"
				aria-haspopup="true"
				onClick={handleToggle}
			>
				{getTranslateByKey("information.homepageRegister")}
				{isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
			</S.StyledButton>
			<Popper
				className="mui-poper-register"
				open={isOpen}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === "bottom" ? "center top" : "center bottom",
						}}
					>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList autoFocusItem={isOpen} id="menu-list-grow" onKeyDown={handleListKeyDown}>
									{OPTIONS_REGISTER.map((option, index) => (
										<MenuItem key={index} onClick={handleClose}>
											<Link to={String(option.key)}>
												<S.SubPage>{option.value}</S.SubPage>
											</Link>
										</MenuItem>
									))}
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
			{/* <S.StyledMenu
        id="id-homepage-register-dropdown"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        {OPTIONS_REGISTER.map((option, index) => (
          <MenuItem
            key={index}
            onClick={handleClose}
          >
            <Link
              to={String(option.key)}
            >
              <S.SubPage>{option.value}</S.SubPage>
            </Link>
          </MenuItem>
        ))}
      </S.StyledMenu> */}
		</S.Container>
	);
}

export default RegisterMenu;
